import { DataCache } from '../../components/data-driven-logo/data-cache';
import { useSellerLabelProvider } from '../../hooks/use-seller-label-provider';
import { useSellerFulfillmentProvider } from '../../hooks/use-seller-fulfillment-provider';
import { useSellerFreightProvider } from '../../hooks/use-seller-freight-provider';
import { ProviderTypes } from '../constants';

const getProviderReferences = () => ({
  useSellerAccountHook: useSellerLabelProvider,
  reduxReferenceKey: 'labelProviderId',
  collection: DataCache.getCachedProviders(),
  cacheReferenceKey: 'providerId',
});

const getFillProviderReferences = () => ({
  useSellerAccountHook: useSellerFulfillmentProvider,
  reduxReferenceKey: 'fulfillmentProviderId',
  collection: DataCache.getCachedFillProviders(),
  cacheReferenceKey: 'fillProviderId',
});

const getFreightProviderReferences = () => ({
  useSellerAccountHook: useSellerFreightProvider,
  reduxReferenceKey: 'freightProviderId',
  collection: DataCache.getCachedFreightProviders(),
  cacheReferenceKey: 'freightProviderId',
});

const providerTypeToReferenceBag = {
  [ProviderTypes.shipping]: getProviderReferences,
  [ProviderTypes.fulfillment]: getFillProviderReferences,
  [ProviderTypes.freight]: getFreightProviderReferences,
};

export const getBag = (providerType) => providerTypeToReferenceBag[providerType]?.() || getProviderReferences();
